'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultActionNames = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _createReducer = require('../../creators/createReducer');

var _createReducer2 = _interopRequireDefault(_createReducer);

var _onLoading = require('../../effects/onLoading');

var _onLoading2 = _interopRequireDefault(_onLoading);

var _onSuccess = require('../../effects/onSuccess');

var _onSuccess2 = _interopRequireDefault(_onSuccess);

var _onFailure = require('../../effects/onFailure');

var _onFailure2 = _interopRequireDefault(_onFailure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Let the user specify selectors
var reducerDescription = {
  LOADING: (0, _onLoading2.default)(),
  SUCCESS: (0, _onSuccess2.default)(),
  FAILURE: (0, _onFailure2.default)()
};

var defaultActionNames = exports.defaultActionNames = (0, _keys2.default)(reducerDescription);

// TODO: Let user specify this initialState
exports.default = (0, _createReducer2.default)({}, reducerDescription);